import { render, staticRenderFns } from "./TheTitleText.vue?vue&type=template&id=80b08d02&scoped=true&lang=pug&"
import script from "./TheTitleText.vue?vue&type=script&lang=js&"
export * from "./TheTitleText.vue?vue&type=script&lang=js&"
import style0 from "./TheTitleText.vue?vue&type=style&index=0&id=80b08d02&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80b08d02",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/opt/build/repo/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardTitle } from 'vuetify/lib'
installComponents(component, {VCardTitle})
